export const faAlignTop = {
  prefix: 'fpm',
  iconName: 'fa-align-top',
  icon: [
    24,
    24,
    [],
    'e001',
    'M3 4.5V5h18.64V4H3v.5m3.76 8.32v6.54h3.92V6.28H6.76v6.54m7.2-2.28v4.26h3.92V6.28h-3.92v4.26',
  ],
};
